<template>
	<rmp-master-account-access-application-base-step v-if="initialized" :title="tc('titles.attachDocumentsList')">
		<v-container class="pa-0">
			<v-row class="mb-4" no-gutters>
				<v-col>
					<rmp-text tag="span" type="body-large" :color="colors.grey.darken1">
						{{ confirmRightPerformActionsText }}
					</rmp-text>
				</v-col>
			</v-row>
			<v-row>
				<rmp-form-col>
					<rmp-dropzone :type="STORAGE_INN_NAMESPACE"
								  :label="tc('fields.headCertificateInn.label')"
								  max-size="100"
								  required
								  @file:add="addFile($event, STORAGE_INN_NAMESPACE)"
								  @file:delete="deleteFile(STORAGE_INN_NAMESPACE)">
					</rmp-dropzone>
				</rmp-form-col>
				<rmp-form-col v-if="selectCounterpartyStepStore.counterpartyType === CounterpartyTypeEnum.LEGAL_ENTITY">
					<rmp-dropzone :type="STORAGE_APPOINTMENT_HEAD_ORDER"
								  :label="tc('fields.appointmentHeadOrder.label')"
								  max-size="100"
								  required
								  @file:add="addFile($event, STORAGE_APPOINTMENT_HEAD_ORDER)"
								  @file:delete="deleteFile(STORAGE_APPOINTMENT_HEAD_ORDER)">
					</rmp-dropzone>
				</rmp-form-col>
			</v-row>
		</v-container>
	</rmp-master-account-access-application-base-step>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import { CounterpartyTypeEnum } from "@rmp/core/types/CounterpartyTypeEnum";
import RmpMasterAccountAccessApplicationBaseStep
	from "@rmp/id/views/masterAccountAccess/steps/RmpMasterAccountAccessApplicationBaseStep.vue";
import RmpDropzone from "@rmp/core/components/dropzone/RmpDropzone.vue";
import RmpFormCol from "@rmp/core/components/form/RmpFormCol.vue";
import { STORAGE_APPOINTMENT_HEAD_ORDER, STORAGE_INN_NAMESPACE } from "@rmp/core/constants/storage";
import { useColors } from "@rmp/core/composables/useColors";
import { useI18n } from "vue-i18n-composable";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { usePage } from "@rmp/core/composables/usePage";
import { useMasterAccountAccessDocumentsStepStore } from "@rmp/id/stores/masterAccountAccess/steps/documents";
import { useMasterAccountAccessSelectCounterpartyStepStore } from "@rmp/id/stores/masterAccountAccess/steps/selectCounterparty";

const { colors } = useColors();

const { tc } = useI18n();

const selectCounterpartyStepStore = useMasterAccountAccessSelectCounterpartyStepStore();

const { counterpartyType } = useMasterAccountAccessSelectCounterpartyStepStore();
const useStore = useMasterAccountAccessDocumentsStepStore;
const store = useStore();

let { documents } = storeToRefs(store);

const { processFile, removeFile } = useStore();

const confirmRightPerformActionsText = computed(() => {
	const legalEntityText = tc("common.masterAccountAccessDocumentsStep.legalEntity");
	const legalPersonText = tc("common.masterAccountAccessDocumentsStep.legalPerson");
	const isLegalEntity = CounterpartyTypeEnum.LEGAL_ENTITY === selectCounterpartyStepStore.counterpartyType;
	
	const counterpartyText = isLegalEntity ? legalEntityText : legalPersonText;
	
	return `${tc("common.masterAccountAccessDocumentsStep.toConfirmRightPerformActionsOnBehalfOf")} ${counterpartyText}, 
	${tc("common.masterAccountAccessDocumentsStep.attachDocumentsListBelow")}.`;
});

const addFile = async (file: any, docType: string) => {
	await processFile({ fileId: file.id, docType });
};
const deleteFile = (docType: string) => {
	removeFile(docType);
};

const { initialized } = usePage({ useStore });
</script>

<style lang="scss">

</style>

